import { Component } from "@angular/core";

@Component({
  selector: 'app-nav-mobile-panel',
  templateUrl: './nav-mobile-panel.component.html',
  styleUrls: ['./nav-mobile-panel.component.css']
})

export class NavMobilePanelComponent {
  ngOnInit(): void {

    const self = this;
  }
}
